export default "__VITE_ASSET__24d13335__"